import React from 'react'
import DefaultLayout from '../DefaultLayout'

const ProductPriceWrapper = () => {
    return (
        <div className='py-10 bg-main-100'>
            <DefaultLayout className='px-6 text-main-800'>
                <>
                    <h2 className='text-2xl font-semibold mb-12 text-center'>
                        価格表
                    </h2>

                    <div className='grid sm:grid-cols-2 gap-6 gap-y-10'>
                        <div>
                            <h3 className='mb-2 text-main-800 font-semibold text-xl text-center'>リング</h3>

                            <table className="table-auto w-full text-sm text-center text-gray-500 mb-10">
                                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                                    <tr className='bg-main-600 text-white text-xl'>
                                        <th colSpan={3} className="py-3 text-center border-r border-white">種別</th>
                                        <th colSpan={7} className="py-3 text-center">価格（税抜）</th>
                                    </tr>
                                </thead>
                                <tbody className='text-base sm:text-lg border border-white text-main-800'>
                                    <tr className='bg-main-200 border border-white'>
                                        <td colSpan={3} className="py-3 border-r border-white">販売</td>
                                        <td colSpan={7} className="py-3">150,000円/個</td>
                                    </tr>
                                    <tr className='bg-main-100'>
                                        <td colSpan={3} className="py-3 border-r border-white">レンタル</td>
                                        <td colSpan={7} className="py-3">月額&nbsp;6,000円/個</td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* <div className='text-center font-semibold text-base sm:text-xl border border-white'>
                                <dl className='flex bg-main-600 text-white border-y-2 border-white'>
                                    <dt className='py-4 w-52 sm:w-60 border-r-2 border-white'>種別</dt>
                                    <dd className='py-4 w-full'>価格（税抜）</dd>
                                </dl>
                                <dl className='flex bg-main-200 border-y-2 border-white'>
                                    <dt className='py-4 w-52 sm:w-60 border-r-2 border-white'>販売</dt>
                                    <dd className='py-4 w-full'>150,000円/個</dd>
                                </dl>
                                <dl className='flex border-y-white border'>
                                    <dt className='py-4 w-52 sm:w-60 border-r-2 border-white'>レンタル</dt>
                                    <dd className='py-4 w-full'>月額&nbsp;6,000円/個</dd>
                                </dl>
                            </div> */}
                        </div>

                        <div>
                            <h3 className='mb-2 text-main-800 font-semibold text-xl text-center'>充電ケース</h3>

                            <table className="table-auto w-full text-sm text-center text-gray-500 mb-10">
                                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                                    <tr className='bg-main-600 text-white text-xl'>
                                        <th colSpan={3} className="py-3 text-center border-r border-white">種別</th>
                                        <th colSpan={7} className="py-3 text-center">価格（税抜）</th>
                                    </tr>
                                </thead>
                                <tbody className='text-base sm:text-lg border border-white text-main-800'>
                                    <tr className='bg-main-200 border border-white'>
                                        <td colSpan={3} className="py-3 border-r border-white">販売</td>
                                        <td colSpan={7} className="py-3">10,000円/個</td>
                                    </tr>
                                    <tr className='bg-main-100'>
                                        <td colSpan={3} className="py-3 border-r border-white">レンタル</td>
                                        <td colSpan={7} className="py-3">月額&nbsp;1,000円/個</td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* 
                            <div className='text-center font-semibold text-base sm:text-xl border border-white'>
                                <dl className='flex bg-main-600 text-white border-y-2 border-white'>
                                    <dt className='py-4 w-52 sm:w-60 border-r-2 border-white'>種別</dt>
                                    <dd className='py-4 w-full'>価格（税抜）</dd>
                                </dl>
                                <dl className='flex bg-main-200 border-y-2 border-white'>
                                    <dt className='py-4 w-52 sm:w-60 border-r-2 border-white'>販売</dt>
                                    <dd className='py-4 w-full'>10,000円/個</dd>
                                </dl>
                                <dl className='flex border-y-white border'>
                                    <dt className='py-4 w-52 sm:w-60 border-r-2 border-white'>レンタル</dt>
                                    <dd className='py-4 w-full'>月額&nbsp;1,000円/個</dd>
                                </dl>
                            </div> */}

                        </div>
                    </div>

                </>
            </DefaultLayout>
        </div>
    )
}

export default ProductPriceWrapper